var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenderMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3301",
    "data-name": "Group 3301",
    transform: "translate(-1371 -1189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3017",
    "data-name": "Rectangle 3017",
    width: 23,
    height: 23,
    transform: "translate(1371 1189)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_9_5",
    "data-name": "Component 9 \\u2013 5",
    transform: "translate(1377 1188.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M353.277,68.92,352,67.69,355.991,64l3.991,3.69L358.7,68.92l-2.714-2.767Z",
    transform: "translate(-350.462 -61.541)",
    fill: "#0b88ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M480,96h1.537v8.115H480Z",
    transform: "translate(-475.24 -92.772)",
    fill: "#0b88ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M293.528,491.057a5.528,5.528,0,1,1,5.528-5.528A5.6,5.6,0,0,1,293.528,491.057Zm0-9.477a3.949,3.949,0,1,0,3.949,3.949A3.911,3.911,0,0,0,293.528,481.579Z",
    transform: "translate(-288 -469.733)",
    fill: "#0b88ba"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderMale);
export default __webpack_public_path__ + "static/media/gender_male.e119f5a9d9a25ee8fd51289813c99674.svg";
export { ForwardRef as ReactComponent };